(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('MediaViewerController', mediaViewer);

  mediaViewer.$inject = ['$scope', '$http', '$stateParams', '$location'];

  function mediaViewer ($scope, $http, $stateParams, $location) {
    	var vm = this;
  }
})();
